import { ConfirmationModal } from 'modules/ui';
import { TICKET_LINKED } from 'modules/application/detail/users/UsersSegmentEvents';
export class TicketLinkModalController {
    static $inject = ['ModalService', 'HistoryService', 'TicketLinkService', 'BlipToastService', '$scope', '$translate', 'SegmentService', 'originatorTicket', 'onRefresh', 'close'];
    constructor(ModalService, HistoryService, TicketLinkService, BlipToastService, $scope, $translate, SegmentService, originatorTicket, onRefresh, close) {
        this.ModalService = ModalService;
        this.HistoryService = HistoryService;
        this.TicketLinkService = TicketLinkService;
        this.BlipToastService = BlipToastService;
        this.$scope = $scope;
        this.$translate = $translate;
        this.SegmentService = SegmentService;
        this.originatorTicket = originatorTicket;
        this.onRefresh = onRefresh;
        this.close = close;
        this.isSaving = false;
        this.isLoading = false;
        this.disableSearch = true;
        this.onChangeTicket = (event) => {
            this.ticketSequentialId = event?.detail?.value;
            this.disableSearch = this.ticketSequentialId == '';
            if (!this.$scope.$$phase) {
                this.$scope.$apply();
            }
        };
    }
    async $onInit() {
        this.confirmLabel = await this.$translate('utils.forms.confirm');
        this.cancelLabel = await this.$translate('utils.forms.cancel');
        this.modalTitle = await this.$translate('modules.application.detail.attendance.history.ticketLink.modalTitle');
        document
            .getElementById('ticket-sequential-id')
            .addEventListener('bdsChange', this.onChangeTicket);
    }
    async getTicketData(sequentialId) {
        try {
            this.ticketToLink = null;
            this.isLoading = true;
            const data = await this.HistoryService.get(`SequentialId eq ${sequentialId}`, 0, 1);
            if (data.items.length == 0) {
                const message = await this.$translate('modules.application.detail.attendance.history.ticketLink.ticketNotFound');
                this.BlipToastService.show('info', { msg: message });
                return;
            }
            this.ticketToLink = data.items[0];
            this.ticketToLink.status = this.getStatusName(this.ticketToLink);
            this.modalBody = await this.$translate('modules.application.detail.attendance.history.ticketLink.confirmMessage', { linkedTicket: this.ticketToLink.sequentialId, ticket: this.originatorTicket.sequentialId });
        }
        catch (_) {
            const message = await this.$translate('modules.application.detail.attendance.history.ticketLink.error');
            this.BlipToastService.show('danger', { msg: message });
        }
        finally {
            this.isLoading = false;
        }
    }
    getAgentEmail() {
        if (this.ticketToLink.agentIdentity === null) {
            return '';
        }
        return this.ticketToLink.agentIdentity.split('@')[0].replace('%40', '@');
    }
    getStatusName(ticket) {
        if (ticket.status === 'ClosedClientInactivity') {
            if (ticket.agentIdentity) {
                return 'DroppedInactivity';
            }
            return 'MissedInactivity';
        }
        if (ticket.status === 'ClosedClient') {
            if (ticket.agentIdentity) {
                return 'Dropped';
            }
            return 'Missed';
        }
        if (ticket.status === 'Open') {
            if (ticket.firstResponseDate) {
                return 'InAttendance';
            }
            return 'WaitingResponse';
        }
        return ticket.status;
    }
    async saveMerge() {
        try {
            if (!this.ticketToLink)
                return;
            const modal = await this.ModalService.showModal(ConfirmationModal({
                title: {
                    text: this.modalTitle,
                },
                body: this.modalBody,
                buttons: {
                    confirm: {
                        text: this.confirmLabel,
                    },
                    cancel: {
                        text: this.cancelLabel,
                    },
                },
            }));
            const confirmation = await modal.close;
            if (!confirmation)
                return;
            this.isSaving = true;
            await this.TicketLinkService.save(this.originatorTicket.id, this.ticketToLink.id);
            const message = await this.$translate('modules.application.detail.attendance.history.ticketLink.success');
            this.BlipToastService.show('success', { msg: message });
            this.SegmentService.createApplicationTrack({
                trackEvent: TICKET_LINKED,
                payload: {
                    ticketId: this.originatorTicket.id,
                    linkedTicketId: this.ticketToLink.id,
                },
            });
            await this.onRefresh();
            this.close();
        }
        catch (error) {
            console.error(error);
            const message = await this.$translate('modules.application.detail.attendance.history.ticketLink.error');
            this.BlipToastService.show('danger', { msg: message });
        }
        finally {
            this.isSaving = false;
        }
    }
}
TicketLinkModalController.$inject = ['ModalService', 'HistoryService', 'TicketLinkService', 'BlipToastService', '$scope', '$translate', 'SegmentService', 'originatorTicket', 'onRefresh', 'close'];
